var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Frame } from "framer";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
var SelectContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n"])), theme.border.radius, colors.background.three);
var SelectOption = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  flex-grow: 1;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  flex-grow: 1;\n"])));
var ActiveBackground = styled(Frame)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: ", " !important;\n  transition: 0.25s border ease-out;\n  border: ", " ", " ", ";\n  background-color: ", "1F !important;\n"], ["\n  border-radius: ", " !important;\n  transition: 0.25s border ease-out;\n  border: ", " ", " ", ";\n  background-color: ", "1F !important;\n"])), theme.border.radius, theme.border.width, theme.border.style, colors.green, colors.green);
var InlineSelectInput = function (_a) {
    var options = _a.options, value = _a.value, onValueChange = _a.onValueChange;
    var controlRefs = useMemo(function () {
        return options.reduce(function (acc, section) { return (__assign(__assign({}, acc), section.reduce(function (sectionAcc, option) {
            sectionAcc[option.value] = React.createRef();
            return sectionAcc;
        }, {}))); }, {});
    }, [options]);
    var _b = useState(false), activeBackgroundState = _b[0], setActiveBackgroundState = _b[1];
    /**
     * Update background
     */
    useEffect(function () {
        var currentCurrency = controlRefs[value].current;
        if (!currentCurrency) {
            return;
        }
        var handleResize = function () {
            setActiveBackgroundState({
                left: currentCurrency.offsetLeft,
                top: currentCurrency.offsetTop,
                height: currentCurrency.clientHeight,
                width: currentCurrency.clientWidth,
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [value, controlRefs]);
    return (_jsxs(SelectContainer, { children: [_jsx(ActiveBackground, { transition: {
                    type: "keyframes",
                    ease: "easeOut",
                }, initial: {
                    height: 0,
                    width: 0,
                }, animate: activeBackgroundState }, void 0), options.map(function (section, index) { return (_jsxs(React.Fragment, { children: [section.map(function (option) { return (_jsx(SelectOption, __assign({ ref: controlRefs[option.value], role: "button", onClick: function () { return onValueChange(option.value); } }, { children: option.display(option.value === value) }), option.value)); }), index !== options.length - 1 && (_jsx("div", { style: { height: "50%", width: "1px", background: colors.text } }, void 0))] }, index)); })] }, void 0));
};
export default InlineSelectInput;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=InlineSelectInput.js.map